import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-24 text-center">
        <p className="text-xs font-label font-semibold tracking-[0.15em] text-primary-600 uppercase mb-4">
          Dependable Transit for Trinidad
        </p>
        <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-900 leading-tight mb-4">
          Ready to
          <br />
          <em className="text-primary-500 font-medium">ride with us?</em>
        </h2>
        <p className="text-base md:text-lg text-foreground-600 leading-relaxed max-w-[520px] mx-auto mb-10">
          No reservations needed for fixed routes. Just show up at a stop and climb aboard.
          We run every day of the year.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Link
            to="/airport-shuttle"
            className="inline-flex items-center px-8 py-4 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            View Schedules
          </Link>
          <Link
            to="/contact-us"
            className="inline-flex items-center px-8 py-4 border-2 border-primary-500 text-primary-600 text-sm font-semibold rounded-full hover:bg-primary-50 transition-colors whitespace-nowrap"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </section>
  );
}